import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// config
import useDynamicConfig from 'hooks/useDynamicConfig';

// ==============================|| GUEST GUARD ||============================== //

const GuestGuard = ({ children }: GuardProps) => {
  const { isLoggedIn, activeRole } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { DEFAULT_ROLE_BASED_PATH } = useDynamicConfig();

  useEffect(() => {
    if (isLoggedIn && activeRole) {
      const returnUrl = searchParams.get('returnUrl');

      if (returnUrl) {
        // returnUrl already contains the full path + query string (see AuthGuard), so it must
        // be passed as a single string and parsed by the router, not split across
        // `to.pathname`/`to.search` — react-router throws if `to.pathname` itself contains '?'.
        navigate(returnUrl, { replace: true });
      } else {
        navigate(
          {
            pathname: DEFAULT_ROLE_BASED_PATH[activeRole.user_role_type_id],
            search: searchParams.get('search') || undefined
          },
          { replace: true }
        );
      }
    }
  }, [isLoggedIn, navigate, searchParams, activeRole, DEFAULT_ROLE_BASED_PATH]);

  return children;
};

export default GuestGuard;
